import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles((theme) => ({
  relative: {
    marginRight: ".5rem",
  },
  absolute: {
    position: "absolute",
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
  actionButtons: {
    lineHeight: "1.5rem",
    whiteSpace: "nowrap",
  },
  actionButtonIcons: {
    marginRight: ".5rem",
  },
}));
